import * as React from 'react'
import Box from '@mui/material/Box'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Chip from '@mui/material/Chip'

export default function MultipleSelect({
    selectItems,
    label,
    initialValue = [],
    onChange,
}) {
    const [value, setValue] = React.useState(initialValue)

    const [open, setOpen] = React.useState(false)

    const handleClose = () => {
        setOpen(false)
    }

    const handleOpen = () => {
        setOpen(true)
    }

    const handleChange = event => {
        const {
            target: { value },
        } = event
        // On autofill we get a stringified value.
        const newSelected = typeof value === 'string' ? value.split(',') : value
        setValue(newSelected)
        setOpen(false)
        onChange(newSelected)
    }

    return (
        <FormControl
            sx={{
                minWidth: 300,
                marginTop: 2,
                marginBottom: 2,
            }}
        >
            <InputLabel id="multiple-chip-label">{label}</InputLabel>
            <Select
                labelId="multiple-chip-label"
                id="multiple-chip"
                open={open}
                multiple
                value={value}
                onClose={handleClose}
                onOpen={handleOpen}
                onChange={handleChange}
                input={
                    <OutlinedInput id="select-multiple-chip" label={label} />
                }
                renderValue={selected => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map(value => (
                            <Chip key={value} label={value} />
                        ))}
                    </Box>
                )}
            >
                {selectItems.map(name => (
                    <MenuItem key={name} value={name}>
                        {name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
